import { getUid } from 'Services/WeaverUtils'

export setNodes = (payload) ->
  type: 'SET_NODES'
  payload:
    data: payload

export setRootNodes = (payload) ->
  type: 'SET_ROOT_NODES'
  payload:
    data: payload

export setTreeNodes = (payload) ->
  type: 'SET_TREE_NODES'
  payload:
    data: payload

export clearTree = ->
  type: 'CLEAR_TREE'

export toggleExpanded = (key, isExpanded) ->
  type: 'TOGGLE_EXPANDED'
  payload:
    data: { key, isExpanded }

export setLoading = (bool) ->
  type: 'SET_LOADING'
  payload:
    data: bool
